import { render, staticRenderFns } from "./MainLedgerProjectTypeCRUD.vue?vue&type=template&id=c3658fb2"
import script from "./MainLedgerProjectTypeCRUD.vue?vue&type=script&lang=js"
export * from "./MainLedgerProjectTypeCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports